import './AccordionToggle.css';

export const AccordionToggle = ({ 
  children, 
  isExpanded = false,
  onClick,
  className = '' 
}) => {
  const iconClass = `accordion-toggle__icon ${
    isExpanded ? 'accordion-toggle__icon--expanded' : ''
  }`.trim();

  return (
    <button
      className={`accordion-toggle ${className}`.trim()}
      onClick={onClick}
      type="button"
      aria-expanded={isExpanded}
    >
      <span className="accordion-toggle__text">
        {children}
      </span>
      <svg
        className={iconClass}
        width="11.503"
        height="6.504"
        viewBox="0 0 11.503 6.504"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M0.5 0.5L5.751 5.751L11.003 0.5"
          stroke="#207DE9"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};

